/** Same base URL used for login, refresh, profile, etc. (matches REACT_APP_API_URL, no trailing slash). */
export function getApiBaseUrl() {
  return String(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
}
